var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStyleTwoPinMarkerFill = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_106_372)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0C9.48126 0.00264713 7.06643 1.00439 5.28541 2.78541C3.50439 4.56643 2.50265 6.98126 2.5 9.5C2.5 16.05 9 22 11 23.65C11.2687 23.8763 11.6087 24.0005 11.96 24.0005C12.3113 24.0005 12.6513 23.8763 12.92 23.65C15 22 21.5 16.05 21.5 9.5C21.4974 6.98126 20.4956 4.56643 18.7146 2.78541C16.9336 1.00439 14.5187 0.00264713 12 0ZM12 14.5C11.0111 14.5 10.0444 14.2068 9.22215 13.6573C8.3999 13.1079 7.75904 12.327 7.3806 11.4134C7.00216 10.4998 6.90315 9.49445 7.09607 8.52455C7.289 7.55464 7.7652 6.66373 8.46447 5.96447C9.16373 5.2652 10.0546 4.789 11.0245 4.59607C11.9945 4.40315 12.9998 4.50216 13.9134 4.8806C14.827 5.25904 15.6079 5.8999 16.1573 6.72215C16.7068 7.54439 17 8.51109 17 9.5C17 10.1566 16.8707 10.8068 16.6194 11.4134C16.3681 12.02 15.9998 12.5712 15.5355 13.0355C15.0712 13.4998 14.52 13.8681 13.9134 14.1194C13.3068 14.3707 12.6566 14.5 12 14.5Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_106_372"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgStyleTwoPinMarkerFill);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/style-two-pin-marker_fill.1ee0dcf292e6b3b545b36efefb702e27.svg";